import { dillardsModal } from '../../modules/modal/_dillardsModalNode';
import { submitEmailSignupForm, ajaxEmailSignup } from '../../modules/modal/_ajaxEmailSignup';
import { submitTextSignupForm, ajaxTextSignup } from '../../modules/modal/_ajaxTextSignup';
import { bannerCarousels_dt, splashCarousel_dt } from '../../modules/carousel/_bannerCarousels';
import { lazyLoadImage } from '../../modules/global/_lazyLoadImage';
import { loadlazy } from '../../modules/global/_lazyload';
import { responsiveGenericCarousel_dt, responsiveSplashCarousel_dt } from '../../modules/carousel/_responsiveCarousel';
import { formValidation } from '../../modules/global/_formValidation';
import { myFavoritesInit } from '../../modules/global/_myFavoritesPersonalization';
import { personalizationInit } from '../../modules/global/_personalization'
import { setCookieOrWebStorage } from '../../modules/global/_cookies';
import { allDevicesPanelIconToggle } from '../../modules/productDisplay/_panelIconToggle.js';
import { outdatedBrowserCheck } from '../../modules/deviceSpecific/_browserCheck';
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/modal";

var Dillards = window.Dillards || (window.Dillards = {});

if (typeof Dillards !== 'undefined') {
	Dillards.submitEmailSignupForm = submitEmailSignupForm;
	Dillards.ajaxEmailSignup = ajaxEmailSignup;
	Dillards.ajaxTextSignup = ajaxTextSignup;
	Dillards.submitTextSignupForm = submitTextSignupForm;
	Dillards.formValidation = formValidation;
	Dillards.setCookieOrWebStorage = setCookieOrWebStorage;
}

// var handleForTitlelessTablet = function(){
// 	if ($('.facet-title').length > 0 && $('.tabletPage').length > 0) {
//         $('.facet-title').each(function() {
//             $(this).children('i').remove();

//             if($(this).siblings('ul').children('li').length === 1 && $(this).text() == ""){
//             	$(this).addClass('facet-link');
//             	var link = $(this).siblings('ul').children('li').children('a');
//             	$(link).appendTo($(this));
//               $(this).children('i').remove();
//             }

//         });
//     };
// }

$(document).ready(function () {
	dillardsModal();
	Dillards.triggerModal = dillardsModal.triggerModal;
	//loadlazy();
	//lazyLoadImage();
	//bannerCarousels_dt();
	//splashCarousel_dt();
	formValidation();
	//responsiveGenericCarousel_dt();
	//responsiveSplashCarousel_dt();
	myFavoritesInit();
	personalizationInit();
	//allDevicesPanelIconToggle();
	// handleForTitlelessTablet();
	outdatedBrowserCheck();
	Cookies = Cookies;
	$(window).on('reactappupdate', function () {
		//lazyLoadImage(true);
		//splashCarousel_dt();
		//bannerCarousels_dt();
		//responsiveGenericCarousel_dt();
		//responsiveSplashCarousel_dt();
		//allDevicesPanelIconToggle();
		// handleForTitlelessTablet();
	});

//	$(window).on(
//		'resize',
//		_.throttle(function () {
//			if ($('img[usemap]').length > 0) {
//				$('img[usemap]').trigger('load');
//			}
//		}, 500)
//	);

	$('li#flag-icon-footer a, li#flag-icon-mobile a').off('click.changeCountry');
	$('li#flag-icon-footer a, li#flag-icon-mobile a').on('click.changeCountry', function () {
		Dillards.setCookieOrWebStorage('sessionStorage', 'lastLoc', document.location.href);
	});
});

$(window).trigger('belowfoldfinished');
